import { AssitanceVehicle, Cancellation, Covid } from '../icons'

export const ExtraInsuranceCestovkoItemIconsEnum = {
  AssistanceVehicle: 'assistance-vehicle',
  CancellationInsurance: 'cancellation-insurance',
  Covid: 'covid',
} as const

export type ExtraInsuranceCestovkoItemIconsEnum = typeof ExtraInsuranceCestovkoItemIconsEnum[keyof typeof ExtraInsuranceCestovkoItemIconsEnum]

export const getExtraInsuranceCestovkoIcon = (
  icon: ExtraInsuranceCestovkoItemIconsEnum,
  size: string = '48px',
  color: string = 'gray.800',
) => {
  switch (icon) {
    case 'assistance-vehicle':
      return <AssitanceVehicle width={size} height={size} color={color} />
    case 'cancellation-insurance':
      return <Cancellation width={size} height={size} color={color} />
    case 'covid':
      return <Covid width={size} height={size} color={color} />
  }
}
